import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 19 22",
  "content": "<symbol viewBox=\"0 0 19 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"phone\"><path d=\"m8.6 6.6c.3-.3.4-1 .1-1.3l-2.8-3.8c-.3-.5-.9-.6-1.3-.3l-1 .6c-2 1.5-2.6 3.5-2.6 3.5s-.3 4.7 3.2 9.4c3.9 5.3 7.1 5.9 8.3 6.2 1.2.5 4.2-1.4 4.2-1.4l.8-.6c.5-.3.6-.9.3-1.4l-2.8-3.7c-.3-.5-1.1-.6-1.4-.3l-2.9 2c-.5.3-1.1.2-1.4-.2l-4-5.4\" fill=\"none\" stroke=\"#9c7446\" stroke-miterlimit=\"10\" stroke-width=\"1.15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol